import { SearchCardLoader } from '@commerce-product-webcomponents/ui';
import { ProductCardLoadersProps } from './types/propTypes';

const ProductCardLoaders = ({ limit, className }: ProductCardLoadersProps) => {
  const items = [...Array(limit)].map((_, index) => index);
  return (
    <>
      {items.map((value) => (
        <li key={value} data-testid="search-loader-test-id">
          <SearchCardLoader className={className} isFlexibleWidthCard />
        </li>
      ))}
    </>
  );
};

export default ProductCardLoaders;
